// The admin console has no per-branch deploy branding — one env only.
const IS_PROD_ENV = true

export const DOCUMENT_TITLE_BRAND = 'TheCarGo'
export const DOCUMENT_TITLE_SEPARATOR = ' · '
export const DOCUMENT_TITLE_SEGMENT_MAX_LENGTH = 30
export const DOCUMENT_TITLE_TRUNCATION_SUFFIX = '…'

/**
 * Leading marker on non-production tabs so a dev tab is never mistaken for the
 * real one — it sits before the unread count because a narrow tab truncates
 * from the right. The static title in index.html and the gray icon set get the
 * same treatment at build time (`brandNonProdHtml` in `vite.config.ts`).
 */
export const DOCUMENT_TITLE_ENV_PREFIX = IS_PROD_ENV ? '' : 'Dev · '
